/**
 * Jagad Jawa — Kamus Bahasa Indonesia (id)
 * Standar: 100% Bahasa Indonesia baku dengan pelestarian istilah budaya baku (weton, neptu, wuku, pasaran, pranata mangsa, dll).
 */
export const id = {
  "brand_subtitle": "Portal Budaya Nusantara",
  "lang_toggle_badge": "ID",
  "lang_toggle_title": "Ganti Bahasa (Indonesia / Jawa)",
  "nav_beranda": "Beranda",
  "nav_wektu": "Waktu & Penanggalan",
  "nav_kalender": "Kalender Jawa",
  "nav_kalender_sub": "Pasaran, Dino Ala/Becik & Weton",
  "nav_konversi": "Konversi Tanggal",
  "nav_konversi_sub": "Masehi ke Jawa & Pranata Mangsa",
  "nav_nujum": "Nujum & Primbon",
  "nav_nujum_pribadi": "Nujum Pribadi",
  "nav_nujum_sub": "Watak Bincil, Faalakiah, & Shio",
  "nav_jodoh": "Perjodohan (Pitung)",
  "nav_jodoh_sub": "Petung Jodoh Salaki Rabi & Neptu",
  "nav_selametan": "Peringatan Wafat",
  "nav_selametan_sub": "Selametan Geblak hingga Nyewu",
  "nav_ijab": "Petung Ijab (Palakrama)",
  "nav_ijab_sub": "Neptu Khusus, Wuku, & Surasa",
  "nav_omah": "Petung Omah & Cempuri",
  "nav_omah_sub": "Pembangunan, Boyongan, & Lawang",
  "nav_ternak": "Petung Kehidupan",
  "nav_ternak_sub": "Ternak, Loro, & Geblak",
  "nav_ternak_pemula": "Petung Wiwit Ternak",
  "nav_ternak_ahli": "Petung Kehidupan (Ternak, Loro, Geblak)",
  "nav_sasmitha": "Sasmitha (Tanda Alam)",
  "nav_sasmitha_sub": "Impen, Kedut, Gerhana, Lindu",
  "nav_sasmitha_pemula": "Sasmitha (Impen & Kedut)",
  "nav_sasmitha_ahli": "Sasmitha (Tanda Alam & Tubuh)",
  "nav_primbon": "Primbon",
  "nav_belajar": "Belajar",
  "nav_saya": "Saya",
  "mode_ringkas": "Ringkas",
  "mode_lengkap": "Lengkap",
  "mode_banner_text": "Mode Ringkas aktif untuk pengalaman cepat & ramah pemula.",
  "nav_budaya": "Seni & Budaya",
  "nav_wuku": "Ensiklopedia 30 Wuku",
  "nav_wuku_sub": "Pawukon Jawa: Sinta hingga Watugunung",
  "nav_tripurusa": "Telur Jagad (Tripurusa)",
  "nav_tripurusa_sub": "Mitologi Antaga, Ismaya, Manikmaya",
  "nav_ensiklo_budaya": "Ensiklopedia Budaya",
  "nav_ensiklo_budaya_sub": "6 Bincil, Shio, Zodiak & Neptu",
  "nav_mitologi": "Mitologi Nusantara",
  "nav_mitologi_sub": "Asal-Usul Wuku, Pasaran & Cerita Kuno",
  "nav_gamelan": "Gamelan Maya",
  "nav_gamelan_sub": "Gamelan Maya Pelog & Slendro",
  "nav_aksara": "Studio Aksara Jawa",
  "nav_aksara_sub": "Papan Ketik & Transliterasi Aksara",
  "nav_wayang": "Panggung Kelir Wayang",
  "nav_wayang_sub": "Simulasi Wayang Kulit Interaktif",
  "nav_pitutur": "Pitutur Luhur & Kuis",
  "nav_pitutur_sub": "Falsafah Luhur & Uji Wawasan",
  "nav_pustaka": "Pustaka Digital",
  "nav_pustaka_sub": "Naskah Kuno, Kamus & Usada",
  "nav_sinengker": "Pustaka Sinengker",
  "nav_sinengker_sub": "Kompas Danyang & Aji Wingit",
  "nav_laporan": "Pusat Laporan Tradisi Luhur",
  "nav_laporan_sub": "Dokumen Resmi & Cetak PDF",
  "hero_badge": "Warisan Adiluhung",
  "hero_today_tag": "Hari Ini",
  "hero_btn_share_card": "Bagikan Kartu",
  "hero_btn_share_text": "Bagikan Teks",
  "hero_quick_actions_title": "Aksi Cepat · Pilihan Populer",
  "hero_quick_weton": "Cek Weton",
  "hero_quick_weton_desc": "Kalender & Pasaran",
  "hero_quick_jodoh": "Petung Jodoh",
  "hero_quick_jodoh_desc": "Salaki Rabi & Neptu",
  "hero_quick_ijab": "Hari Baik Ijab",
  "hero_quick_ijab_desc": "Palakrama Manten",
  "hero_quick_selametan": "Selametan",
  "hero_quick_selametan_desc": "Geblak hingga Nyewu",
  "hero_title": "MENYELAMI KEARIFAN LOKAL",
  "hero_desc": "Menjelajahi Kebudayaan Luhur Nusantara dalam ruang kosmik berestetika adiluhung — komputasi kalender Jawa, primbon petungan, studio aksara, kelir wayang, dan alunan gamelan.",
  "hero_banner_tag": "Portal Budaya Terpadu · Warisan Luhur Nusantara",
  "card_stories_tag": "CERITA",
  "card_stories_title": "Jelajah Cerita",
  "card_stories_desc": "Falsafah hidup, pitutur luhur para leluhur Jawa, serat piwulang, serta panggung kelir wayang purwa.",
  "card_stories_action": "Buka Falsafah",
  "card_archive_tag": "ARSIP",
  "card_archive_title": "Arsip Budaya",
  "card_archive_desc": "Arsip komputasi kalender Jawa, siklus Pranata Mangsa, nujum weton kepribadian, serta petung perjodohan.",
  "card_archive_action": "Buka Arsip",
  "card_community_tag": "KOMUNITAS",
  "card_community_title": "Pawiyatan Komunitas",
  "card_community_desc": "Pembelajaran gamelan maya interaktif, studio transliterasi aksara Hanacaraka, dan ruang pengetahuan budaya.",
  "card_community_action": "Masuk Pawiyatan",
  "btn_back": "← Kembali",
  "btn_back_home": "← Kembali ke Beranda",
  "btn_close": "Tutup",
  "btn_share_weton": "Bagikan Weton",
  "btn_save_note": "Simpan Catatan",
  "btn_copy": "Salin",
  "btn_print": "Cetak Laporan",
  "btn_download": "Unduh",
  "btn_download_png": "Unduh Gambar (PNG)",
  "btn_download_pdf": "Ekspor PDF",
  "btn_calculate": "Hitung",
  "btn_reset": "Atur Ulang",
  "btn_reset_today": "Hari Ini",
  "btn_search": "Cari",
  "btn_see_more": "Lihat Lagi",
  "btn_dismiss": "Tutup Hari Ini",
  "cal_header_title": "Kalender Jawa · Pranata Mangsa",
  "cal_header_subtitle": "Dihitung otomatis berbasis siklus Pasaran (5), Wuku (210), dan Tahun Jawa/Hijriah.",
  "cal_saring_label": "Saring Hari:",
  "cal_filter_all": "Semua Hari",
  "cal_filter_ijo": "Hari Baik (Becik)",
  "cal_filter_gede": "Hari Besar (Dino Gede)",
  "cal_filter_bookmark": "Tersimpan (Bookmark)",
  "cal_btn_print": "Cetak Laporan",
  "cal_btn_download": "Unduh Gambar (PNG)",
  "cal_mode_grid": "Mode Tabel (Grid)",
  "cal_mode_list": "Mode List Minggu",
  "cal_scroll_hint": "Geser tabel secara horizontal untuk melihat seluruh hari & wuku",
  "cal_label_bulan": "Pilih Bulan:",
  "cal_label_tahun": "Tahun Masehi:",
  "cal_click_hint": "*Klik kotak tanggal untuk rincian lengkap, tanda catatan, & bagikan weton",
  "cal_wuku_ngisor_hint": "Nomor 4, 14, 24 — kala di bawah, jangan menuju arah tempat wuku!",
  "modal_dino_gede_title": "HARI BESAR TRADISI",
  "modal_dino_gede_desc": "Hari penting dan sakral dalam perhitungan pawukon & penanggalan Jawa.",
  "modal_dino_lumrah_title": "HARI BIASA",
  "modal_dino_lumrah_desc": "Tidak termasuk peringatan Hari Besar khusus.",
  "modal_status_ala_title": "STATUS: HARI BURUK / PANTANGAN",
  "modal_status_ala_desc": "Hari yang dihindari untuk mendirikan rumah, pernikahan, atau bepergian jauh.",
  "modal_status_becik_title": "STATUS: HARI BAIK / RAHAYU",
  "modal_status_becik_desc": "Hari baik untuk berbagai hajat, bepergian, dan memulai pekerjaan.",
  "sapa_dina_title": "Sapa Dina — Ringkasan Harian",
  "sapa_dina_weton_title": "Weton Pasaran Hari Ini",
  "sapa_dina_neptu_title": "Perhitungan Neptu",
  "sapa_dina_status_ijo": "Hari Baik (Rahayu)",
  "sapa_dina_status_ala": "Hari Pantangan (Kurang Baik)",
  "sapa_dina_status_gede": "Hari Besar Tradisi",
  "sapa_dina_pitutur_title": "Falsafah & Nasihat Bijak Harian",
  "sapa_dina_tetanen_title": "Pedoman Bercocok Tanam & Palawija",
  "sapa_dina_pranata_title": "Kosmologi Pranata Mangsa",
  "tab_kalender_title": "Kalender Jawa · Pranata Mangsa",
  "tab_kalender_desc": "Dihitung otomatis berbasis siklus Pasaran (5), Wuku (210), dan Tahun Jawa/Hijriyah.",
  "tab_nujum_title": "Nujum Kepribadian & Primbon",
  "tab_nujum_desc": "Watak 6 dimensi Bincil, zodiak pranata, shio elemen, watak hari, dan ramalan falakiah.",
  "tab_jodoh_title": "Petung Perjodohan (Pitung Jawa)",
  "tab_jodoh_desc": "Kesesuaian pernikahan berdasarkan neptu, babon wuku, aksara lintang, dan sisa modulo 4/5/7/8.",
  "tab_selametan_title": "Peringatan Wafat (Selametan)",
  "tab_selametan_desc": "Perhitungan hari geblak, 3 hari, 7 hari, 40 hari, 100 hari, pendak 1, pendak 2, hingga nyewu (1000 hari).",
  "tab_ijab_title": "Petung Ijab (Palakrama)",
  "tab_ijab_desc": "Sistem Neptu Khusus Ijab, babon wuku pernikahan, surasa weton, dan keselarasan sasi/tahun.",
  "tab_omah_title": "Petung Omah & Cempuri",
  "tab_omah_desc": "Pedoman mendirikan rumah, boyongan, sembilan posisi pintu cempuri, dan larangan arah.",
  "tab_kehidupan_title": "Petung Kehidupan (Ternak, Penyakit, Geblak)",
  "tab_kehidupan_desc": "Pedoman memulai ternak, jaluran penyakit tradisional, dan tata cara penghormatan duka geblak.",
  "tab_sasmitha_title": "Sasmitha (Tanda Alam & Tubuh)",
  "tab_sasmitha_desc": "Tafsir mimpi tradisional, makna kedutan anatomi tubuh, gerhana, gempa (lindu), dan teja.",
  "tab_wuku_title": "Ensiklopedia 30 Wuku Nusantara",
  "tab_wuku_desc": "Jelajahi siklus 30 wuku dari Sinta hingga Watugunung beserta Batara Pelindung dan 4 pilar petenget.",
  "tab_aksara_title": "Studio Aksara Jawa",
  "tab_aksara_desc": "Papan ketik digital dan transliterasi instan Latin ke Hanacaraka dengan aturan sandhangan & pasangan.",
  "tab_wayang_title": "Panggung Kelir Wayang Kulit",
  "tab_wayang_desc": "Simulasi interaktif pementasan wayang kulit dengan blencong temaram, efek kepyak, dan tokoh wayang.",
  "tab_konversi_title": "Konversi Tanggal Jawa (Sultan Agungan & Masehi)",
  "tab_konversi_desc": "Transformasi matematis akurat antara kalender Masehi (Gregorian) dengan Kalender Jawa Sultan Agungan sejak 1555 Saka.",
  "tab_tripurusa_title": "Telur Jagad (Tripurusa)",
  "tab_tripurusa_desc": "Mitologi penciptaan semesta dan asal mula Batara Manikmaya, Ismaya, serta Antaga.",
  "tab_ensiklo_budaya_title": "Ensiklopedia Budaya & Kosmologi Jawa",
  "tab_ensiklo_budaya_desc": "Rujukan mendalam 6 dimensi Bincil, zodiak pranata, shio wuxing, dan siklus padewan.",
  "tab_mitologi_title": "Mitologi Nusantara & Dongeng Kuna",
  "tab_mitologi_desc": "Asal-usul pawukon Watugunung, legenda Dewi Sri, dan cerita mistis tanah Jawa.",
  "tab_gamelan_title": "Gamelan Maya Interaktif",
  "tab_gamelan_desc": "Alunan karawitan gamelan Jawa maya pelog & slendro dengan synthesizer audio autentik.",
  "tab_pitutur_title": "Pitutur Luhur & Kuis Wawasan Budaya",
  "tab_pitutur_desc": "Mutiara falsafah leluhur Jawa dan cangkriman untuk menguji wawasan kebudayaan.",
  "tab_tumpeng_title": "Tumpeng Tombak Rojo & Ubarampe Sesaji",
  "tab_tumpeng_desc": "Makna filosofis ubarampe sesaji, tumpeng tradisi Jawa, dan doa keselamatan Jawa.",
  "tab_pustaka_title": "Pustaka Digital Jawa & Serat Kuno",
  "tab_pustaka_desc": "Koleksi digital manuskrip kuno, usada rempah jamu tradisional, doa, dan serat piwulang luhur.",
  "tab_sinengker_title": "Pustaka Sinengker & Rahasia Gaib",
  "tab_sinengker_desc": "Pengetahuan wingit tradisi leluhur Jawa, kompas danyang 360°, aji rajah kalacakra, dan ruwatan.",
  "tab_laporan_title": "Pusat Laporan Tradisi Luhur & Ekspor Dokumen",
  "tab_laporan_desc": "Cetak piagam weton berpigura emas, ringkasan nujum pribadi, dan dokumen pawiwahan.",
  "mode_ringkas_aktif": "Mode Ringkas Aktif:",
  "mode_ringkas_kal_desc": "Tampilan kalender fokus pada hari dan pasaran harian. Opsi ekspor cetak dan panduan kode disembunyikan.",
  "mode_ringkas_nujum_desc": "Formulir disederhanakan untuk nujum kepribadian dasar. Komparasi relasi dan opsi cetak disimpan.",
  "mode_switch_lengkap": "Beralih ke Mode Lengkap",
  "cal_btn_reset_today": "Hari Ini",
  "cal_btn_export_pdf": "Ekspor PDF",
  "cal_legend_hijau_label": "Blok Hijau Solid",
  "cal_legend_hijau_desc": "Hari Baik / Rahayu (74 Hari)",
  "cal_legend_merah_label": "Blok Merah Solid",
  "cal_legend_merah_desc": "Hari Buruk / Pantangan (136 Hari)",
  "nujum_label_tgl_lahir": "Tanggal Lahir (Masehi)",
  "nujum_label_nama": "Nama Lengkap (Untuk Faalakiah)",
  "nujum_label_tahun": "Tahun Hitung",
  "nujum_label_alamat_tinggal": "Alamat Tinggal (Nama Kelurahan)",
  "nujum_label_alamat_kerja": "Alamat Tempat Kerja (Nama Kelurahan)",
  "nujum_placeholder_nama": "Contoh: Raden Mas Dananjaya",
  "nujum_placeholder_tinggal": "Contoh: Delanggu",
  "nujum_placeholder_kerja": "Contoh: Gatak",
  "nujum_btn_hitung": "Hitung Nujum Lengkap",
  "nujum_badge_tgl_jawa": "Tanggal Jawa",
  "nujum_badge_hari_pasaran": "Hari & Pasaran",
  "nujum_badge_neptu_wuku": "Neptu & Wuku",
  "nujum_badge_siklus": "Siklus Tahunan",
  "nujum_badge_karakter": "Karakter Dasar",
  "nujum_badge_sirikan": "Sirikan Hadap Omah",
  "nujum_empty_state": "Klik tombol \"Hitung Nujum Lengkap\" untuk menampilkan analisis lengkap kepribadian, bincil, faalakiah nabi, asesoris ageman, dan watak wuku.",
  "nujum_btn_glosarium": "Glosarium & Panduan Filosofi",
  "nujum_subtab_pribadi": "Nujum Kepribadian Pribadi",
  "nujum_subtab_nonjodoh": "Komparasi Relasi (Non-Jodoh)",
  "nujum_nonjodoh_title": "Komparasi Sinergi Relasi & Kerja Sama (Non-Jodoh)",
  "nujum_nonjodoh_desc": "Analisis keselarasan watak, titik temu komunikasi, potensi friksi, dan etika kerja sama (tepa slira) untuk rekan kerja, mitra usaha, sahabat, maupun keluarga tanpa perhitungan pernikahan.",
  "nujum_nonjodoh_p1": "Pihak Pertama (Orang 1)",
  "nujum_nonjodoh_p2": "Pihak Kedua (Orang 2)",
  "nujum_nonjodoh_label_nama": "Nama Lengkap / Panggilan:",
  "nujum_nonjodoh_label_tgl": "Tanggal Lahir (Masehi):",
  "nujum_nonjodoh_label_konteks": "Konteks Relasi:",
  "nujum_nonjodoh_btn_bandingkan": "Bandingkan Karakter & Sinergi",
  "jodoh_label_status": "Status Hubungan Pasangan:",
  "jodoh_status_belum": "Rencana Menikah (Calon Pengantin)",
  "jodoh_status_planning": "Rencana Menikah (Calon Pengantin)",
  "jodoh_status_engaged": "Lamaran / Tunangan",
  "jodoh_status_sudah": "Sudah Menikah (Pasutri)",
  "jodoh_status_married": "Sudah Menikah (Pasutri)",
  "jodoh_wanita_title": "Data Calon Pengantin Wanita (♀)",
  "jodoh_pria_title": "Data Calon Pengantin Pria (♂)",
  "jodoh_label_nama": "Nama Lengkap (Opsional)",
  "jodoh_label_aksara_depan": "Aksara Depan",
  "jodoh_label_aksara_belakang": "Aksara Belakang",
  "jodoh_label_tgl_lahir": "Tanggal Lahir (Wajib)",
  "jodoh_label_hari": "Hari",
  "jodoh_label_pasaran": "Pasaran",
  "jodoh_label_neptu": "Neptu Dina + Pasaran:",
  "jodoh_btn_hitung": "Hitung Nujum Perjodohan",
  "jodoh_empty_title": "Petung Salaki Rabi (Pitung Perjodohan)",
  "jodoh_empty_desc": "Silakan pilih status hubungan, tentukan tanggal lahir calon pengantin wanita dan pria, lalu klik tombol \"Hitung Nujum Perjodohan\" untuk melihat analisis kecocokan dan rekomendasi.",
  "jodoh_hasil_title": "Hasil Nujum Jejodohan Miturut Pitung Jawa",
  "jodoh_tabel_no": "No",
  "jodoh_tabel_hasil": "Hasil Petung",
  "jodoh_tabel_arti": "Arti / Wedharan",
  "jodoh_tabel_status": "Status",
  "jodoh_wizard_step1": "Langkah 1 dari 4: Status Hubungan Pasangan",
  "jodoh_wizard_step2": "Langkah 2 dari 4: Data Calon Pengantin Pria",
  "jodoh_wizard_step3": "Langkah 3 dari 4: Data Calon Pengantin Wanita",
  "jodoh_wizard_step4": "Langkah 4 dari 4: Ringkasan Hasil & 7 Metode Pitung",
  "jodoh_wizard_btn1": "1. Status",
  "jodoh_wizard_btn2": "2. Calon Pria",
  "jodoh_wizard_btn3": "3. Calon Wanita",
  "jodoh_wizard_btn4": "4. Hasil & 7 Metode",
  "jodoh_lanjut_wanita": "Lanjut ke Data Calon Wanita (Langkah 3)",
  "jodoh_lanjut_pria": "Lanjut ke Data Calon Pria (Langkah 2)",
  "jodoh_lanjut_hasil": "Hitung & Lihat Hasil (Langkah 4)",
  "jodoh_kembali_status": "Kembali ke Status Hubungan (Langkah 1)",
  "jodoh_kembali_wanita": "Kembali ke Data Calon Wanita (Langkah 3)",
  "jodoh_kembali_pria": "Kembali ke Data Calon Pria (Langkah 2)",
  "jodoh_detail_accordion_title": "Lihat Analisis Lengkap 7 Metode Pitung",
  "jodoh_cta_buka_ijab": "Buka Rekomendasi Hari Baik di Petung Ijab",
  "jodoh_riwayat_title": "Riwayat Hitungan Pasangan",
  "jodoh_riwayat_desc": "Tersimpan secara lokal di peramban Anda (privasi terjamin)",
  "jodoh_riwayat_hapus": "Bersihkan Semua",
  "selametan_wizard_step1": "Langkah 1 dari 3: Tanggal Wafat / Geblak",
  "selametan_wizard_step2": "Langkah 2 dari 3: Waktu Berpulang (Sebelum / Bakda Maghrib)",
  "selametan_wizard_step3": "Langkah 3 dari 3: Jadwal 7 Milestone Pengetan",
  "selametan_wizard_btn1": "1. Tanggal Wafat",
  "selametan_wizard_btn2": "2. Waktu Berpulang",
  "selametan_wizard_btn3": "3. Jadwal Pengetan",
  "selametan_lanjut_waktu": "Lanjut ke Waktu Berpulang (Langkah 2)",
  "selametan_lanjut_jadwal": "Lihat Jadwal 7 Milestone (Langkah 3)",
  "selametan_kembali_tanggal": "Kembali ke Tanggal Wafat (Langkah 1)",
  "selametan_kembali_waktu": "Kembali ke Waktu Berpulang (Langkah 2)",
  "selametan_waktu_unselected_error": "Pilih waktu wafat (sebelum Maghrib atau bakda Maghrib) terlebih dahulu.",
  "selametan_opt_siang_title": "Siang / Sebelum Maghrib (Sadèrèngipun Surup)",
  "selametan_opt_siang_desc": "Wafat sebelum pukul 18.00 sore. Tanggal Masehi dan hari Jawa tetap sama sebagai hari Geblak.",
  "selametan_opt_malam_title": "Malam / Bakda Maghrib (Bakda Surup)",
  "selametan_opt_malam_desc": "Wafat setelah pukul 18.00 sore. Hari Jawa berganti ke hari berikutnya sesuai kaidah Sultan Agungan.",
  "selametan_detail_accordion_title": "Lihat Rincian Lengkap Seluruh 7 Milestone & Tabel",
  "selametan_label_nama": "Nama Almarhum / Almarhumah (Opsional)",
  "selametan_placeholder_nama": "Contoh: Ki Ageng Suryo / Ibu Warsiti",
  "selametan_label_tgl_wafat": "Tanggal Wafat / Geblak (Masehi — Wajib)",
  "selametan_label_waktu": "Waktu Berpulang (Surup / Maghrib — Wajib Dipilih)",
  "selametan_opt_siang": "Siang / Sebelum Maghrib (Tanggal Masehi = Hari Geblak)",
  "selametan_opt_malam": "Malam / Setelah Maghrib (Surup — Hari Jawa berganti ke esok)",
  "selametan_label_keyakinan": "Refleksi Doa & Keyakinan (Inklusif 6 Agama)",
  "selametan_lintas_agama": "Lintas Agama & Budaya",
  "selametan_warning_title": "Penting — Pergantian Hari Jawa:",
  "selametan_warning_desc": "Dalam tradisi Jawa, hari berganti setelah pukul 18.00 (sore/surup). Jika wafat setelah pukul 18.00, maka hari yang dipakai adalah hari berikutnya.",
  "selametan_btn_hitung": "Hitung Selametan",
  "selametan_hasil_title": "Rincian Hari Peringatan Selametan",
  "selametan_tabel_pengetan": "Peringatan",
  "selametan_tabel_dina": "Hari + Pasaran",
  "selametan_tabel_tgl": "Tanggal Masehi",
  "selametan_tabel_ket": "Keterangan",
  "selametan_note": "*Selametan umumnya diselenggarakan pada sore/malam hari (setelah Maghrib / pukul 18.00) sesuai adat istiadat setempat.",
  "ijab_badge": "Paugeran Palakrama",
  "ijab_label_tgl": "Tanggal Akad (Masehi)",
  "ijab_label_dina": "Dina",
  "ijab_label_pasaran": "Pasaran",
  "ijab_label_wuku": "Wuku Palakrama",
  "ijab_label_sasi": "Sasi Jawa",
  "ijab_label_tahun": "Tahun Jawa (Windu)",
  "ijab_label_tgl_jawa": "Tanggal Jawa (1-30)",
  "ijab_label_panjampet": "Parameter Panjampet Pilihan (Opsional):",
  "ijab_autofill_hint": "Otomatis mengisi Hari, Pasaran, Wuku, & Sasi Jawa.",
  "ijab_btn_hitung": "Petung Ijab (Tampilkan Ketentuan)",
  "ijab_btn_today": "Hari Ini",
  "intent_title": "Saya Ingin...",
  "intent_subtitle": "Pintu Pintar Fitur Luhur",
  "intent_weton": "Cek Weton",
  "intent_weton_sub": "Hari & Pasaran",
  "intent_jodoh": "Hitung Jodoh",
  "intent_jodoh_sub": "7 Metode Pitung",
  "intent_ijab": "Hari Akad Ijab",
  "intent_ijab_sub": "Palakrama Rahayu",
  "intent_selametan": "Selametan Wafat",
  "intent_selametan_sub": "Geblak s/d Nyewu",
  "intent_omah": "Petung Omah",
  "intent_omah_sub": "Cempuri & Pindah",
  "intent_ternak": "Ternak & Tanam",
  "intent_ternak_sub": "Wiwit Ingon-ingon",
  "ijab_wizard_step1": "Langkah 1 dari 4: Sumber Data & Tanggal Akad",
  "ijab_wizard_step2": "Langkah 2 dari 4: Keselarasan Weton & Wuku",
  "ijab_wizard_step3": "Langkah 3 dari 4: Parameter Panjampet Pilihan",
  "ijab_wizard_step4": "Langkah 4 dari 4: Rekomendasi & Hasil Evaluasi",
  "ijab_wizard_btn1": "1. Sumber Data",
  "ijab_wizard_btn2": "2. Weton & Wuku",
  "ijab_wizard_btn3": "3. Panjampet",
  "ijab_wizard_btn4": "4. Rekomendasi",
  "ijab_lanjut_weton": "Lanjut ke Weton & Wuku (Langkah 2)",
  "ijab_lanjut_panjampet": "Lanjut ke Panjampet (Langkah 3)",
  "ijab_lanjut_rekomendasi": "Lihat Rekomendasi & Hasil (Langkah 4)",
  "ijab_kembali_tanggal": "Kembali ke Sumber Data (Langkah 1)",
  "ijab_kembali_weton": "Kembali ke Weton & Wuku (Langkah 2)",
  "ijab_kembali_panjampet": "Kembali ke Panjampet (Langkah 3)",
  "saya_badge": "Profil & Pengetahuan Pribadi",
  "saya_title": "Pribadi & Setelan Aplikasi",
  "saya_desc": "Kelola weton kelahiran pribadi, simpanan perhitungan, serta preferensi tampilan Jagad Jawa.",
  "saya_weton_title": "Weton Pribadi Saya",
  "saya_weton_stored": "Tersimpan di Perangkat",
  "saya_label_tgl_lahir": "Tanggal Lahir Anda",
  "saya_weton_label": "Weton Lahir",
  "saya_wuku_label": "Wuku Lahir",
  "saya_pick_date": "Pilih tanggal lahir",
  "saya_pref_title": "Preferensi Tampilan & Bahasa",
  "saya_mode_title": "Mode Antarmuka",
  "saya_mode_desc": "Pilih antara Mode Ringkas (pemula) atau Mode Lengkap (ahli).",
  "saya_mode_btn": "Ubah Mode",
  "saya_bahasa_title": "Bahasa / Basa",
  "saya_bahasa_desc": "Beralih antara Bahasa Indonesia dan Basa Jawi.",
  "saya_bahasa_btn": "Ganti Bahasa (ID/JV)",
  "saya_tema_title": "Tema Visual",
  "saya_tema_desc": "Pilihan nuansa gelap (peteng) atau terang (padhang).",
  "saya_tema_btn": "Ganti Tema",
  "saya_dokumen_title": "Pusat Dokumen & Laporan PDF",
  "saya_dokumen_desc": "Akses berkas ekspor laporan penanggalan, primbon jodoh, dan arsip tradisi luhur.",
  "saya_dokumen_btn": "Buka Pusat Dokumen",
  "bottomnav_beranda": "Beranda",
  "bottomnav_kalender": "Kalender",
  "bottomnav_primbon": "Primbon",
  "bottomnav_belajar": "Belajar",
  "bottomnav_saya": "Saya",
  "btn_next": "Lanjut",
  "btn_prev": "Kembali",
  "btn_hapus_semua": "Hapus Semua",
  "btn_export_pdf": "Ekspor PDF",
  "lbl_opsional": "Opsional",
  "toast_share_success": "Berhasil dibagikan! ✨",
  "toast_copy_success": "Teks berhasil disalin ke clipboard!",
  "toast_save_success": "Data berhasil disimpan.",
  "toast_kalender_reset": "Kalender kembali ke bulan & hari ini ✨",
  "menu_card_kalender_title": "Kalender Jawa",
  "menu_card_kalender_desc": "Masehi, Pasaran, Wuku, Dino Gede, dan status Ala/Becik.",
  "menu_card_nujum_title": "Nujum Kepribadian",
  "menu_card_nujum_desc": "Bincil, Faalakiah 12 Nabi dari nama, Asesoris, & Karakter.",
  "menu_card_jodoh_title": "Pitung Perjodohan",
  "menu_card_jodoh_desc": "Kecocokan 7 metode primbon aksara & neptu jodoh.",
  "menu_card_selametan_title": "Peringatan Wafat",
  "menu_card_selametan_desc": "Peringatan 3, 7, 40, 100, Pendak 1-2, dan Nyewu 1000 hari.",
  "menu_card_ijab_title": "Petung Ijab (Palakrama)",
  "menu_card_ijab_desc": "Sistem Neptu Khusus Ijab, babon wuku, surasa weton, dan sasi.",
  "menu_card_omah_title": "Petung Omah & Cempuri",
  "menu_card_omah_desc": "Bumi, Kerta, Guru (sisa modulo), 9 cempuri pintu, & larangan arah.",
  "menu_card_ternak_ringkas_title": "Petung Memulai Ternak",
  "menu_card_ternak_lengkap_title": "Petung Kehidupan",
  "menu_card_ternak_ringkas_desc": "Pedoman memulai ternak hewan peliharaan (Gajah, Suku, Watu, Buto).",
  "menu_card_ternak_lengkap_desc": "Memulai ternak, jaluran sakit & obat, serta wiradat 40 hari geblak.",
  "menu_card_sasmitha_ringkas_title": "Sasmitha Mimpi & Kedutan",
  "menu_card_sasmitha_lengkap_title": "Sasmitha (Tanda Alam & Tubuh)",
  "menu_card_sasmitha_ringkas_desc": "Tafsir 99 mimpi & pertanda 74 kedutan bagian tubuh.",
  "menu_card_sasmitha_lengkap_desc": "Pengetahuan mimpi, kedutan, gerhana, gempa bumi sasi, & cahaya langit.",
  "menu_card_aksara_title": "Studio Aksara Jawa",
  "menu_card_aksara_desc": "Transliterasi otomatis Latin ke Hanacaraka & kanvas tulis.",
  "menu_card_wayang_title": "Panggung Kelir Wayang",
  "menu_card_wayang_desc": "Simulasi pementasan wayang dengan blencong & kepyak.",
  "menu_card_gamelan_title": "Gamelan Maya",
  "menu_card_gamelan_desc": "Tabuh Saron, Bonang, Kempul & Gong (Slendro & Pelog).",
  "menu_card_pitutur_title": "Pitutur & Kuis Wawasan",
  "menu_card_pitutur_desc": "Falsafah hidup dan kuis wawasan budaya bergelar.",
  "menu_card_tumpeng_title": "Tumpeng Tombak Rojo",
  "menu_card_tumpeng_desc": "Filosofi 5 warna, peta perlengkapan sesaji tolak bala, dan doa keselamatan.",
  "hero_pitutur_header": "Pitutur Luhur Hari Ini",
  "hero_pitutur_source": "Falsafah Luhur Jawa",
  "hero_pranata_header": "Pranata Mangsa",
  "hero_kala_header": "Dununge Kala (Arah)",
  "hero_kala_sub": "Arah pantangan perjalanan wuku",
  "hero_tetanen_header": "Petung Tetanen & Palawija",
  "hero_status_gede": "Hari Besar (Sakral)",
  "hero_status_becik": "Hari Baik (Rahayu)",
  "hero_status_ala": "Hari Pantangan (Waspada)",
  "hero_accordion_open": "Buka Rincian Hari Ini & Pitutur",
  "hero_accordion_close": "Tutup Rincian Hari Ini",
  "hero_tetanen_becik": "Yang dianjurkan:",
  "omah_badge": "Kearifan Arsitektur Tradisional",
  "omah_label_tgl": "Tanggal Mendirikan / Pindahan Rumah",
  "omah_tgl_hint": "Otomatis sinkron Hari, Pasaran, & Bulan Jawa.",
  "omah_label_dina": "Dina",
  "omah_label_pasaran": "Pasaran",
  "omah_label_arah_lawang": "Arah Hadap Pintu",
  "omah_label_params": "Parameter Cempuri, Pindahan & Tanah:",
  "omah_label_nomor_lawang": "Posisi Pintu (1-9)",
  "omah_label_arah_pindah": "Arah Pindah Rumah",
  "omah_label_sasi": "Bulan Jawa",
  "omah_label_mangsa": "Pranata Mangsa",
  "omah_label_lemah": "Karakteristik Tanah",
  "omah_btn_hitung": "Petung Rumah (Buka Ketentuan)",
  "omah_search_title": "Pencarian Hari Baik Interaktif",
  "omah_search_desc": "Cari tanggal, bulan, dan tahun yang sesuai untuk mendirikan rumah atau boyongan berdasarkan formula Set A, B, dan C.",
  "omah_search_bulan": "Bulan Masehi",
  "omah_search_tahun": "Tahun Masehi",
  "omah_label_tujuan": "Tujuan Hajat Omah",
  "omah_wizard_step1": "Langkah 1 dari 4: Tujuan, Tanggal & Arah Pintu Utama",
  "omah_wizard_step2": "Langkah 2 dari 4: Posisi Pintu Cempuri (1-9)",
  "omah_wizard_step3": "Langkah 3 dari 4: Karakteristik Lahan & Musim",
  "omah_wizard_step4": "Langkah 4 dari 4: Hasil Evaluasi & Rekomendasi",
  "omah_wizard_btn1": "1. Tujuan & Tanggal",
  "omah_wizard_btn2": "2. Cempuri",
  "omah_wizard_btn3": "3. Lahan & Mangsa",
  "omah_wizard_btn4": "4. Hasil Petung",
  "omah_lanjut_cempuri": "Lanjut ke Posisi Cempuri (Langkah 2)",
  "omah_lanjut_lahan": "Lanjut ke Lahan & Mangsa (Langkah 3)",
  "omah_lanjut_hasil": "Hitung & Lihat Hasil (Langkah 4)",
  "omah_kembali_tanggal": "Kembali ke Tanggal & Arah (Langkah 1)",
  "omah_kembali_cempuri": "Kembali ke Posisi Cempuri (Langkah 2)",
  "omah_kembali_lahan": "Kembali ke Lahan & Mangsa (Langkah 3)",
  "omah_mode_lengkap": "Mode Form Lengkap",
  "omah_mode_ringkas": "Mode Stepper Ringkas",
  "ternak_badge_ringkas": "Pedoman Memulai Ternak",
  "ternak_badge_lengkap": "Petung Kehidupan Sehari-hari",
  "ternak_label_tujuan": "Pilih Tujuan / Aktivitas",
  "ternak_act_ternak_title": "Wiwit Ngingu Raja-Kaya",
  "ternak_act_ternak_desc": "Pedoman 4 Kategori (Gajah, Suku, Watu, Buto)",
  "ternak_act_tetanen_title": "Petung Tetanen & Palawija",
  "ternak_act_tetanen_desc": "Kesesuaian 4 Golongan Tanaman (Oyot, Uwit, Kembang, Uwoh)",
  "ternak_act_loro_title": "Penyebab Sakit & Obat",
  "ternak_act_loro_desc": "Pengobatan tradisi & peringatan medis penting",
  "ternak_act_geblak_title": "Petung Duka & Hari Wafat",
  "ternak_act_geblak_desc": "Wiradat 40 hari & penghormatan almarhum",
  "ternak_btn_hitung": "Hitung Petung Kehidupan",
  "ternak_err_tanggal_wajib": "Tanggal peristiwa atau memulai wajib diisi terlebih dahulu.",
  "ternak_err_weton_wajib": "Dina dan Pasaran wajib dipilih terlebih dahulu.",
  "ternak_label_tgl": "Tanggal Peristiwa / Memulai",
  "ternak_tgl_hint": "Otomatis mendeteksi Hari, Pasaran, dan Neptu.",
  "ternak_search_title": "Pencarian Kecocokan Hari (Interaktif)",
  "ternak_search_desc": "Cari tanggal, bulan, dan tahun yang tepat untuk Memulai Ternak, Penyakit, atau Geblak berdasarkan formula 35 weton.",
  "ternak_search_bidang": "Bidang Petung",
  "ternak_search_kategori": "Kategori / Kriteria",
  "ternak_search_btn": "Cari Hari",
  "ternak_opt_ternak": "Memulai Ternak",
  "ternak_opt_tetanen": "Bercocok Tanam (Tetanen)",
  "ternak_opt_loro": "Penyebab Sakit",
  "ternak_opt_geblak": "Petung Hari Wafat",
  "ternak_opt_kat_becik": "Hari Baik: Gajah & Suku",
  "ternak_opt_kat_gajah": "Kategori Gajah (Agung / Luhur)",
  "ternak_opt_kat_suku": "Kategori Suku (Kaya / Mulia)",
  "ternak_opt_kat_watu": "Kategori Watu (Netral / Prihatin)",
  "ternak_opt_kat_buto": "Kategori Buto (Waspada)",
  "ternak_opt_kat_all": "Semua Kategori",
  "sasmitha_badge_ringkas": "Pedoman Pengetahuan Tradisi",
  "sasmitha_badge_lengkap": "Sasmitha Tanda Alam & Tubuh",
  "aksara_sejarah_badge": "Asal-Usul Carakan Jawa",
  "aksara_sejarah_legend": "Legenda Aji Saka, Dora & Sembada",
  "aksara_sejarah_title": "Sejarah Terjadinya 20 Aksara Jawa (Hanacaraka)",
  "aksara_input_title": "Ketik Teks Latin (Transliterasi Otomatis)",
  "aksara_input_clear": "Hapus Latin",
  "aksara_input_placeholder": "Ketik teks bahasa Jawa atau Indonesia di sini, contoh: sugeng rawuh wonten jagad jawa...",
  "aksara_sample_label": "Contoh Cepat:",
  "aksara_output_title": "Hasil Transliterasi & Editor Aksara Jawa",
  "aksara_output_clear": "Bersihkan",
  "aksara_output_copy": "Salin Aksara",
  "aksara_output_standard": "Kaidah Kongres Bahasa Jawa & Sastra.org",
  "aksara_keyboard_title": "Papan Ketik Virtual Aksara Jawa",
  "aksara_keyboard_desc": "Klik aksara, pasangan, atau sandhangan untuk menyusun teks secara manual langsung di posisi kursor.",
  "gamelan_badge_music": "Seni Karawitan & Sastra Tembang",
  "gamelan_badge_macapat": "11 Tembang Macapat Jawa",
  "gamelan_intro_title": "Pengetahuan Dasar Karawitan",
  "gamelan_macapat_title": "11 Tembang Macapat & Aturan",
  "gamelan_macapat_desc": "Filosofi perjalanan hidup manusia dari benih hingga wafat",
  "pitutur_btn_today": "Pitutur Hari Ini",
  "pitutur_btn_random": "Ganti Pitutur (Acak)",
  "pitutur_btn_copy": "Salin Pitutur",
  "pitutur_btn_share_wa": "Bagikan WhatsApp",
  "pitutur_quiz_title": "Kuis Wawasan Kebudayaan Jawa",
  "pitutur_quiz_desc": "Uji seberapa dalam wawasanmu tentang seni, tradisi, dan sastra Jawa.",
  "pitutur_quiz_soal": "Soal:",
  "pitutur_quiz_skor": "Skor:",
  "wuku_top_badge": "Pawukon Jawa • 210 Hari Satu Siklus",
  "wuku_btn_12_batara": "12 Batara-Batari",
  "wuku_btn_mode_modal": "Mode Dialog Modal",
  "wuku_banner_badge": "Direktori Lengkap Pawukon Jawa",
  "wuku_banner_title": "Siklus 30 Wuku: Sinta hingga Watugunung",
  "wuku_banner_desc": "Setiap wuku berjalan selama tujuh hari (7 hari). Setiap wuku memiliki naungan Dewa, karakter budi pekerti, pantangan bahaya (sengkala), sesaji ruwat keselamatan, serta doa tolak bala untuk menjaga ketenteraman lahir batin.",
  "wuku_search_placeholder": "Cari wuku, dewa, profesi, tanaman...",
  "wuku_hint_click": "Klik salah satu kartu wuku di bawah untuk melihat rincian lengkap",
  "wuku_filter_label": "Pilar Nujum:",
  "wuku_pill_all": "Semua (30 Wuku)",
  "wuku_pill_nambani": "Pengobatan (Usada)",
  "wuku_pill_pangupajiwa": "Mata Pencaharian (Rezeki)",
  "wuku_pill_tetanen": "Pertanian & Tanaman",
  "wuku_pill_ala_becik": "Baik & Buruk",
  "wuku_list_title": "Daftar 30 Wuku (Urut 1 - 30):",
  "wuku_cycle_duration": "Siklus 210 Hari",
  "modal_wuku_title": "Ensiklopedia 30 Wuku Nusantara",
  "modal_wuku_desc": "Direktori lengkap Pawukon Jawa: Sinta hingga Watugunung (Dewa, Karakter, Pantangan, & Ruwatan)",
  "mitologi_top_badge": "Sastra & Mitologi Kuno",
  "mitologi_badge_heritage": "Cerita Warisan Luhur",
  "mitologi_banner_badge": "Kosmologi & Dunia Mistik Jawa",
  "mitologi_banner_title": "Asal-Usul Cerita & Sastra Budaya",
  "mitologi_banner_desc": "Nusantara tersusun dari kekayaan sejarah, kepercayaan purba, dan mitologi adiluhung. Di sini tercatat asal-usul 30 siklus wuku dari tragedi agung Prabu Watugunung, terciptanya 5 pasaran Jawa, serta interaksi gaib para penjaga alam dengan para tokoh linuwih tanah Jawa.",
  "mitologi_btn_read": "Baca Lebih Lengkap",
  "mitologi_modal_font": "Font",
  "mitologi_modal_copy": "Salin Cerita",
  "mitologi_modal_summary_title": "Ringkasan Cerita:",
  "mitologi_modal_tokoh_title": "Tokoh / Unsur Utama:",
  "mitologi_modal_moral_title": "Falsafah & Ajaran Luhur:"
};

export default id;
